// extracted by mini-css-extract-plugin
module.exports = {"Link":"NavbarTitle_Link__3TDOK","imgLogo":"NavbarTitle_imgLogo__1IkCX"};